import { CandidateConversationMode } from '../components/candidate/CandidateConversationMode.js';
import { useNavigate } from 'react-router-dom';

export default function CandidateRepliesPage() {
  const navigate = useNavigate();
  return <CandidateConversationMode onBack={() => navigate('/leads')} />;
}
